import { notificationsSelector } from '@onhandtech/onhand-fe-shared/lib/notifications'
import { NotificationGroup } from '@onhandtech/onhand-toolkit'
import NavigationBar from 'components/navigation/navigation-bar'
import { useSelector } from 'react-redux'
import { Outlet } from 'react-router-dom'

import * as CSS from './admin-layout.styles'

const AdminLayout = () => {
  const notifications = useSelector(notificationsSelector)

  return (
    <CSS.AdminLayout>
      <NotificationGroup notifications={notifications} />
      <NavigationBar />
      <CSS.MainContent>
        <Outlet />
      </CSS.MainContent>
    </CSS.AdminLayout>
  )
}

export default AdminLayout
